import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const AICurriculumLanding = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Check if this is a redirect route
    const userData = localStorage.getItem("user");
    if (userData) {
      const token = btoa(userData); // base64 encode user data
      window.open(
        `https://ai-curriculum.wiserbee.ca/dashboard?wiserbee_token=${encodeURIComponent(token)}`,
        "_self"
      );
    } else {
      window.open("https://ai-curriculum.wiserbee.ca/dashnoard", "_self");
    }
  }, []);

  const handleContinue = () => {
    // Get the WiserBee user data from localStorage
    const userData = localStorage.getItem("user");
    if (userData) {
      const token = btoa(userData); // base64 encode user data
      window.open(
        `https://ai-curriculum.wiserbee.ca?wiserbee_token=${encodeURIComponent(token)}`,
        "_blank"
      );
    } else {
      window.open("https://ai-curriculum.wiserbee.ca", "_blank");
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{
        flex: 1,
        padding: "60px 20px",
        minHeight: "70vh",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          padding: "48px 40px",
          maxWidth: "540px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #241763, #473d78)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 24px",
          }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
          </svg>
        </div>

        <h2
          style={{
            fontSize: "28px",
            fontWeight: "700",
            color: "#1e293b",
            marginBottom: "12px",
          }}
        >
          {t("aiCurriculum") || "AI Curriculum"}
        </h2>

        <p
          style={{
            fontSize: "16px",
            color: "#64748b",
            marginBottom: "32px",
            lineHeight: "1.6",
          }}
        >
          Design, generate, and manage your curriculum with AI-powered tools.
          Create lesson plans, assessments, and pacing guides effortlessly.
        </p>

        <button
          onClick={handleContinue}
          style={{
            background: "linear-gradient(135deg, #241763, #473d78)",
            color: "#fff",
            border: "none",
            borderRadius: "12px",
            padding: "14px 36px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "all 0.2s ease",
            boxShadow: "0 4px 14px rgba(36, 23, 99, 0.4)",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow =
              "0 6px 20px rgba(36, 23, 99, 0.5)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow =
              "0 4px 14px rgba(36, 23, 99, 0.4)";
          }}
        >
          Continue to AI Curriculum →
        </button>
      </div>
    </div>
  );
};

export default AICurriculumLanding;
